/**
 * Tiny logger that gates non-error console output behind NODE_ENV.
 * In production builds (Cradle's `yarn build`) only `error()` reaches the
 * browser console; `warn` / `debug` / `info` are stripped at runtime so
 * we don't leak internal flow to end users.
 *
 * Use this instead of `console.warn` / `console.debug` directly.
 */
const isProd = process.env.NODE_ENV === "production";

export const logger = {
  warn: (...args) => { if (!isProd) console.warn(...args); },
  debug: (...args) => { if (!isProd) console.debug(...args); },
  info: (...args) => { if (!isProd) console.info(...args); },
  // Always keep error so genuine failures surface in Sentry / browser logs.
  error: (...args) => { console.error(...args); },
};

export default logger;
